import * as React from 'react';

function SvgArrowDownRightCircleFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M0 8a8 8 0 1116 0A8 8 0 010 8zm5.904-2.803a.5.5 0 10-.707.707L9.293 10H6.525a.5.5 0 000 1H10.5a.5.5 0 00.5-.5V6.525a.5.5 0 00-1 0v2.768L5.904 5.197z' />
		</svg>
	);
}

export default SvgArrowDownRightCircleFill;
